import React from 'react';
import { NavLink } from 'react-router-dom';
import { MdOutlineAttachMoney } from "react-icons/md";
import { FaEdit } from "react-icons/fa";

import './layout.css';

const AddAccountLayout = ({ children }) => {

  
 
  return (
    <div className="container-fluid">
      <h1 className="layouts-title">
      <FaEdit  className="leave-policy-icon" />
        Edit Account
      </h1>
      <hr />
      <section>
        <div className="nav-container">
          <ul className="nav-list">
            <li className="nav-item">
              <NavLink
                id="add-account-link"
                className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                to="/edit-account"
              >
                <MdOutlineAttachMoney className="nav-icon" />Account
              </NavLink>
            </li>
           
          </ul>
        </div>
        <div className="content">
          {children}
        </div>
      </section>
    </div>
  );
};

export default AddAccountLayout;
